<template>
  <svg
    :height="height"
    :width="width"
    version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 501.551 501.551" style="enable-background:new 0 0 501.551 501.551;" xml:space="preserve">
    <path style="fill:#40596B;" d="M367.804,185.309H20.898C9.404,185.309,0,194.713,0,206.207v273.763
      c0,11.494,9.404,20.898,20.898,20.898h346.906c11.494,0,20.898-9.404,20.898-20.898V206.207
      C388.702,194.713,379.298,185.309,367.804,185.309z"/>
    <path style="fill:#334A5E;" d="M473.339,186.354l-84.637,50.155v213.159l84.637,50.155c13.584,5.224,28.212-5.224,28.212-19.853
      V205.162C501.551,190.534,486.922,181.13,473.339,186.354z"/>
    <circle style="fill:#84DBFF;" cx="295.706" cy="93.358" r="92.996"/>
    <circle style="fill:#40596B;" cx="295.706" cy="93.358" r="8.359"/>
    <g>
      <circle style="fill:#FFFFFF;" cx="295.706" cy="36.934" r="24.033"/>
      <circle style="fill:#FFFFFF;" cx="295.706" cy="149.783" r="24.033"/>
      <circle style="fill:#FFFFFF;" cx="352.131" cy="93.358" r="24.033"/>
      <circle style="fill:#FFFFFF;" cx="239.282" cy="93.358" r="24.033"/>
    </g>
    <circle style="fill:#84DBFF;" cx="92.996" cy="93.358" r="92.996"/>
    <circle style="fill:#40596B;" cx="92.996" cy="93.358" r="8.359"/>
    <g>
      <circle style="fill:#FFFFFF;" cx="92.996" cy="36.934" r="24.033"/>
      <circle style="fill:#FFFFFF;" cx="92.996" cy="149.783" r="24.033"/>
      <circle style="fill:#FFFFFF;" cx="149.42" cy="93.358" r="24.033"/>
      <circle style="fill:#FFFFFF;" cx="36.571" cy="93.358" r="24.033"/>
    </g>
    <rect x="31.347" y="385.93" style="fill:#FFD15C;" width="146.286" height="83.592"/>
    <g>
      <circle style="fill:#FF7058;" cx="259.135" cy="427.726" r="13.584"/>
      <circle style="fill:#FF7058;" cx="307.2" cy="427.726" r="13.584"/>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
